

















import { LanguageKey } from "@/store/modules/common/interfaces";
import {
  DIGITAL_HUMAN_LOADING,
  DIGITAL_HUMAN_SETTING,
  HYGEN_SESSION_ERROR
} from "@/store/modules/digital_human/constants";
import Vue from "vue";
import { mapGetters } from "vuex";
import AppResourseNotFound from "../shared/AppResourseNotFound.vue";
export default Vue.extend({
  components: { AppResourseNotFound },
  name: "DigitalHumanErrorPopup",
  computed: {
    LanguageKey() {
      return LanguageKey;
    },
    ...mapGetters("digital_human", {
      hygen_session_error: HYGEN_SESSION_ERROR,
      bot_setting: DIGITAL_HUMAN_SETTING,
      bot_loading: DIGITAL_HUMAN_LOADING
    })
  }
});
